import { usePaypalCheckoutFlag } from "hooks/useFeatureFlags";

interface Props {
  currencyCode?: string | undefined | null;
}

export function useIsPaypalCheckoutAvailable({ currencyCode = "USD" }: Props) {
  const isPaypalCheckoutEnabled = usePaypalCheckoutFlag();

  if (!isPaypalCheckoutEnabled) {
    return false;
  }

  if (!currencyCode) {
    return false;
  }

  return currencyCode.toUpperCase() === "USD";
}
